var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-wrapper"},[(_vm.showLink)?_c('DocsGithubLink',{attrs:{"href":_vm.linkUrl,"text":_vm.linkText}}):_c('span',[_vm._v(" Local environment ")]),_vm._v(" "),_c('span',[_vm._v("|")]),_vm._v(" "),_c('DocsGithubLink',{attrs:{"text":"Release notes","href":"https://github.com/learningequality/kolibri-design-system/releases"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }